<!--
  @component AuthorizationLayout
  @description Layout del módulo de autorizaciones.
-->
<template>
  <div class="authorization-layout">
    <router-view />
  </div>
</template>

<script>
/**
 * @component AuthorizationLayout
 * @description Layout del módulo de autorizaciones. Wrapper simple con
 * padding y tipografía del sistema de diseño.
 */
export default {
  name: "AuthorizationLayout",
};
</script>

<style scoped>
.authorization-layout {
  padding: 24px 32px 32px 32px;
  font-family: "Plus Jakarta Sans", sans-serif;
}
</style>
